import Waves from '../plugins/waves.min';
window.Waves = Waves;



//////////////////
// WEBPACK FOOTER
// ./src/js/components/global/global-waves.js
// module id = 7
// module chunks = 0